import React, { Component } from 'react';
import axios from "axios/dist/axios.min.js";
import utils from "../../utils/utils";
import "./style.less";

class PipelineRecommendTopGoods extends Component {
  constructor(props) {
    super(props);
    this.state = {
      recommendList: [],
      more: false
    };
  }

  componentDidMount() {
    if (this.props.config.baseConfig.recommendType === '商品') {
      this.getProductListData();
    }
    if (this.props.config.baseConfig.recommendType === '榜单') {
      this.getRankList();
    }
  }

  // 获取排行榜信息
  getRankList = () => {
    const itemList = this.props.config.itemList;
    const idList = itemList.map((item) => {
      return item.id ? item.id : '0';
    });
    axios({
      url: 'https://sh-gateway.shihuo.cn/v4/services/sh-goodsinnerapi/api/inner/top/info?access_token=WphjwI564K8kzs5JQZ',
      method: "post",
      withCredentials: true,
      data: {
        topListIds: idList,
      },
    }).then((res) => {
      if (res.data.status === 0) {
        const list = res.data.data || [];
        // 插入定制化内容
        list.forEach((product) => {
          const customItem = itemList.find((item) => item.id == product.id);
          if (customItem) {
            product.custom_title = customItem.name;
            product.custom_recommend = customItem.recommend;
          }
        });
        this.setState({
          recommendList: list
        })
      }
    });
  }

  // 获取商品信息
  getProductListData = () => {
    const itemList = this.props.config.itemList;
    const idList = itemList.map((item) => {
      return isNaN(Number(item.id)) ? 0 : Number(item.id);
    });

    let reqUrl = "";
    if (this.props.config.baseConfig.productType === "商品id") {
      reqUrl =
        "https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/goods/info?access_token=znSnA7pxO35wtPBaur";
    } else {
      reqUrl =
        "https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/style/info?access_token=znSnA7pxO35wtPBaur";
    }

    axios({
      url: reqUrl,
      method: "post",
      withCredentials: true,
      data: {
        ids: idList,
        sort_tag: this.props.config.baseConfig.sortType === '销量' ? 4 : 0,
        filter_subsidy: this.props.config.baseConfig.shihuoSubsidy === '是' ? 1 : 0,
        from: this.props.specialApiFrom
      },
    }).then((res) => {
      if (res.data.status === 0) {
        const list = res.data.data.List;
        // 插入定制化内容
        list.forEach((product) => {
          const customItem = itemList.find((item) => item.id == product.id);
          if (customItem) {
            product.custom_title = customItem.name;
            product.custom_recommend = customItem.recommend;
          }
        });
        this.setState({
          recommendList: list
        })
      }
    });
  }

  // 图片跳转
  productBannerGo = (url) => {
    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        link: url,
        props: this.props,
      })
      return
    }

    const options = { title: 3 };
    const convertUrl = utils.convertHref(url);
    utils.jumpToUrl(this.props.routeParams,convertUrl,url,options,-1,this.props,false);
  }

  // 商品跳转
  handleItemClick = (item, index) => {
    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        link: item.url,
        props: this.props,
        index
      })
      return
    }

    const baseConfig = this.props.config.baseConfig;
    const options = {
      title: 3,
      sort: index,
      name: item.title
    };
    if (baseConfig.productType === "商品id") {
      options.goods_id = item.id;
    } else {
      options.style_id = item.id;
    }
    utils.jumpToUrl(this.props.routeParams,item.url,item.url,options,-1,this.props);
  }

  // 排行榜跳转
  handleRankClick = (item, index) => {
    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        link: item.href,
        props: this.props,
        index
      })
      return
    }

    const baseConfig = this.props.config.baseConfig;
    const options = {
      title: 5,
      topic_id: item.id,
      sort: index
    };
    if (baseConfig.productType === "商品id") {
      options.goods_id = item.id;
    } else {
      options.style_id = item.id;
    }
    utils.jumpToUrl(this.props.routeParams,item.href,item.href,options,-1,this.props);
  }

  lookMore = () => {
    this.setState({
      more: true
    })
  }

  renderGoods = (item, index) => {
    return (
      <div key={`recommend-goods-${index}`} className="goods-item" onClick={this.handleItemClick.bind(this, item, index)} style={{ backgroundImage: `url(${utils.formatImgUrl(this.props.config.baseConfig.cardImage, this.props.webpSupport)})` }}>
        <img className="goods-item-img" src={utils.formatImgUrl(item.image, this.props.webpSupport)} alt="" />
        <p className="goods-item-title">{item.custom_title || item.title}</p>
        <p className="goods-item-recommend">
          {item.custom_recommend || item.recommend}
          <img src="https://static.shihuocdn.cn/admin/files/20210514/51ea82dcd9eb63f505155f9f4b78dbc4.png" />
        </p>
      </div>
    )
  }

  renderRanks = (item, index) => {
    const img = (item.top_detail && item.top_detail.length > 0) ? item.top_detail[0].pic : '';
    return (
      <div key={`recommend-ranks-${index}`} className="ranks-item" onClick={this.handleRankClick.bind(this, item, index)} style={{ backgroundImage: `url(${utils.formatImgUrl(this.props.config.baseConfig.cardImage, this.props.webpSupport)})` }}>
        <img className="ranks-item-img" src={utils.formatImgUrl(img, this.props.webpSupport)} alt="" />
        <p className="ranks-item-title">{item.custom_title || item.name}</p>
        <p className="ranks-item-recommend">
          {item.custom_recommend || ''}
        </p>
      </div>
    )
  }

  render() {
    const { baseConfig } = this.props.config;
    const { recommendList, more } = this.state;
    const { componentDivideLine } = this.props
    return (
      <div
        id={this.props.config.baseConfig.moduleId}
        className="pipeline-recommendTopGoods"
        style={{
          backgroundColor: baseConfig.bgColor,
        }}
        {...this.props['customAttributes']}
      >
        <div className="title-img">
          <img
            src={utils.formatImgUrl(this.props.config.baseConfig.titleImage, this.props.webpSupport)}
            onClick={this.productBannerGo.bind(this, this.props.config.baseConfig.titleLink)}
            alt=""
          />
        </div>
        <div className="recommend-body">
          {
            recommendList.map((item, index) => {
              if (!more) {
                if (index < 6) {
                  if (this.props.config.baseConfig.recommendType === '榜单') {
                    return this.renderRanks(item, index);
                  }
                  if (this.props.config.baseConfig.recommendType === '商品') {
                    return this.renderGoods(item, index);
                  }
                }
              } else {
                if (this.props.config.baseConfig.recommendType === '榜单') {
                  return this.renderRanks(item, index);
                }
                if (this.props.config.baseConfig.recommendType === '商品') {
                  return this.renderGoods(item, index);
                }
              }
            })
          }
        </div>
        {
          !more &&
          <div className="look-more" onClick={this.lookMore.bind(this)}>
            点击查看更多
          <img src="https://static.shihuocdn.cn/admin/files/20210514/77e488d1fb694f98dd76af9139fad6b4.png" />
          </div>
        }
      </div>
    );
  }
}

export default PipelineRecommendTopGoods;



// WEBPACK FOOTER //
// ./components/pipeline-recommendTopGoods/index.jsx